export default __webpack_public_path__ + "static/media/Montserrat-ThinItalic.f402a295.ttf";